import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AutomationRunsLoadMoreLocation, withAutomationsCategory } from './automationsAnalytics';
import META from './useTrackAutomationRunsLoadMore.meta';

export type UseTrackAutomationRunsLoadMoreParams = {
  automation_id: string;
  location: AutomationRunsLoadMoreLocation;
};

export const useTrackAutomationRunsLoadMore = () => {
  const { track } = useAnalyticsUtilities();

  const trackAutomationRunsLoadMore = useCallback(
    (params: UseTrackAutomationRunsLoadMoreParams) => {
      track(META.name, withAutomationsCategory(params));
    },
    [track],
  );

  return { trackAutomationRunsLoadMore };
};
